import {atom} from "recoil";
import { PersonObject } from "../config/types";
const default_Persons: PersonObject[] = []

export const selectedPersonsR = atom({key:"selectedPersonsR", default:default_Persons})
export const selectedPersonsKeptR = atom({key:"selectedPersonsKeptR", default:default_Persons})